/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {pauseNeighborhoodProgram} from '../api'

export const useMutationPauseNeighborhoodProgram = createReactQueryMutationHook('pauseNeighborhoodProgram', pauseNeighborhoodProgram)
